import React from 'react';

export default function TermsConditions() {
  return (
    <section className="termsConditions">
      <article>
        <h4>Terms And Conditions Applicable To Stockbroking Relationship</h4>
        <div>
          <p>
            The following terms and conditions apply to facilitate effective and
            efficient delivery of our service to you.
          </p>
          <h6>
            1. SKYVIEW CAPITAL working hours are between the hours of 8am and
            5pm each business day In Nigeria (Monday- Friday)
          </h6>

          <ul>
            <h5>MANDATE INSTRUCTIONS</h5>
            <li>
              Client enquiries, stock purchase and stock sale mandate, payment
              advice can be handled via:
            </li>
            <li>
              b. Electronic mail (e-mail; our dedicated email address being
              info@skyviewcapltalng.com)
            </li>
            <li>
              c. Available Mandate forms for walk-in clients at our customer
              service unit.
            </li>
            <li>
              d. The daily transaction deadline for the receipt of stock
              exchange purchase mandate, stock sale mandate and payment advice
              is 6p.m if the business day preceding the date such instructions
              are to be executed.
            </li>
            <li>
              e. All mandates received on weekends or public holidays will be
              treated as received on the business day Immediately following the
              date of actual receipt.
            </li>
          </ul>

          <ul>
            <h5>3. SALE/BUY TRANSACTIONS</h5>
            <li>
              a. In mandates consisting of purchase instruction, the execution
              of such mandates will be dependent on sufficient cleared funds.
            </li>

            <li>
              b. Where a stock purchase mandate Is dependent on the sale
              proceeds of stock, the stock purchase mandate will not be executed
              until the sales transaction has been fully executed, the stock
              purchase mandate will be executed for five business days
              subsequent to the actual date.
            </li>

            <li>
              c. Where the stock for purchase Is still not available after these
              five days, the stock sale mandate will be set aside, and the
              client advised accordingly.
            </li>
          </ul>

          <ul>
            <h5>4. EXECUTION OF MANDATES</h5>
            <li>
              a. In the execution of clients' mandate, SKYVIEW CAPITAL acts as
              stockbroker in an execution capacity and not as financial
              advisors. we will therefore discharge our responsibility to BUY
              and SELL stock on your behalf on The Nigerian stock Exchange.
            </li>
            <li>
              b. SKYVIEW CAPITAL will execute transactions based on the current
              market price of the stock exchange on the date of execution.
            </li>
            <li>
              c. SKYVIEW CAPITAL will apply Its professional expertise and best
              efforts in executing mandates. we however cannot guarantee that a
              mandate will be executed at the market price Indicated on such
              mandates, as market prices are subject to marginal daily changes.
            </li>

            <li>
              {' '}
              d. Mandates will only be attended to when presented in the
              standard format acceptable by SKYVIEW CAPITAL which can be
              downloaded from our website or may be forwarded to our email.{' '}
            </li>
            <li>
              e. SKYVIEW CAPITAL does not accept a range of price for the
              purchase/sale of stocks. Only one price may be indicated. f. On
              execution of your mandate, a notification e-mail will be sent to
              update you of the transaction.
            </li>
          </ul>

          <ul>
            <h5>5. TRANSFER OF ACCOUNT TO SKYVIEW CAPITAL</h5>
            <li>
              a. Where stock was purchased through another stockbroking firm
              before the client transferred his account to SKYVIEW CAPITAL the
              clients should ensure that the resident stockbroking firm has sent
              his/her specimen signature on transfer forms to the respective
              Registrars.
            </li>
          </ul>

          <ul>
            <h5>6. VERIFICATION OF CERTIFICATES</h5>
            <li>
              a. To facilitate prompt verification of certificates, clients
              should endeavor to attach copies of application form, dividend
              warrants and banker's confirmation of the client's signature as
              the case demand.
            </li>
            <li>
              b. SKYVIEW CAPITAL will not be responsible for verification delay
              due to incomplete documentation, irregular signature issue or any
              other reasons outside Its sphere of control.
            </li>
          </ul>

          <ul>
            <h5>7. ORDER OF PAYMENT</h5>

            <li>
              a. Transaction settlement on The Nigerian Stock Exchange is done
              on a trading day plus three days (i.e T+3). In compliance with
              this regulation, payment for sales transaction Is on a trading day
              plus four working days consideration.
            </li>
            <li>
              b. SKYVIEW CAPITAL pays in crossed cheques written in the name of
              the beneficiary whose name appears on the share certificate or
              account holder. The acceptable means of Identification here Is a
              current Driver's license, National Identification card or a
              current International Passport.
            </li>
            <li>
              c. Kindly confirm you have read and agreed to be bound by
              appending your name, signature and the date in the confirmation
              section below.
            </li>
          </ul>
        </div>
      </article>
    </section>
  );
}
